import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getMembershipList = createAsyncThunk(
  "membership/list",
  async ({ pageCount, limit, search }) => {
    const response = await Client(
      API_METHOD.GET,
      url.memberships +
        `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${
          !search ? "" : search
        }`
    );
    return response.data;
  }
);

export const addMembership = createAsyncThunk(
  "membership/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Client(API_METHOD.POST, url.memberships, data);
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

//fetch

export const editMembership = createAsyncThunk(
  "membership/edit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Client(
        API_METHOD.PUT,
        url.memberships + `/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

export const getMembershipCount = async () => {
  const response = await Client(API_METHOD.GET, url.memberships);
  return response.data?.data?.item?.total_count;
};

export const getMembership = createAsyncThunk("membership/one", async (id) => {
  const response = await Client(API_METHOD.GET, url.memberships + `/${id}`);
  return response.data;
});
